import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';

import { Modal } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { BasicPopup } from '../../../Common/basicPopup/BasicPopup';
// import lang from '../../../../assets/i18n/en.json';
import Form from 'react-bootstrap/Form';
import allImages from '../../../../assets/images/allImages';
import { comparePasswords } from '../../../../utils/Utils';
import CustomTooltip from '../../../../helper components/Tooltip/CustomTooltip';
import { UpdateEnterpriseClientPasswordById } from '../../../../Mutations/Mutations';
import { useMutation } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { isLogout } from '../../../../Redux/authSlice';
import { setLoaderFalse, setLoaderTrue } from '../../../../Redux/loaderSlice';
// import { useNavigate } from 'react-router';

export const ChangePassword = (props) => {
  /**
   * DECLARING STATES AND USEEFFECT
   */
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const authReducer = useSelector((state) => state.authReducer);

  const [currentPasswordToggle, setCurrentPasswordToggle] = useState(true);
  const [passwordToggle, setPasswordToggle] = useState(true);
  const [confirmPasswordToggle, setConfirmPasswordToggle] = useState(true);

  const [userData, setUserData] = useState({
    password: '',
    confirmPassword: '',
  });

  const tooltipContent = (
    <>
      <p className="fw-bolder mx-3 my-1">Password Policy</p>
      <ul>
        <li>At least 8 characters in length.</li>
        <li>A mix of uppercase and lowercase letters.</li>
        <li>At least one numerical digit (0-9).</li>
        <li>At least one special character (e.g., !, @, #, $, %, etc.).</li>
      </ul>
    </>
  );
  useEffect(() => {
    setUserData({
      currentPassword: '',
      password: '',
      confirmPassword: '',
    });
  }, []);

  useEffect(() => {
    setError({
      password: false,
      passwordError: '',
      confirmPasswordError: '',
      confirmPassword: false,
    });
  }, [props]);

  const [errors, setError] = useState({
    password: false,
    passwordError: '',
    confirmPasswordError: '',
    confirmPassword: false,
  });

  const [showBasicPopup, setShowBasicPopup] = useState(false);

  //Assign mutaions to variable
  const [changePassword] = useMutation(
    UpdateEnterpriseClientPasswordById,
    {
      onCompleted: (data) => {
        //Animated Loader false
        dispatch(setLoaderFalse());

        props.onHide();
        setShowBasicPopup(true);

        dispatch(isLogout());
        // navigate("/user/login");
        window.location.href = '/user/login';
        // isLoginResponse(data);
      },

      onError: ({ graphQLErrors }) => {
        //Animated Loader false
        dispatch(setLoaderFalse());

        toast.error(toastResponse('error', graphQLErrors[0].message));
        // if (graphQLErrors[0].extensions.response.statusText === "Unauthorized") {
        //     // Check if any of the GraphQL errors have a 401 status code
        //     toast.error(toastResponse('error', ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST));
        // }
      },
    },
  );

  const fnChangePassword = () => {
    try {
      //Animated Loader true
      // dispatch(setLoaderTrue());
      toast.success(toastResponse('success', 'Mutation Not Available'));
      //Call mutaion with parameter
      // changePassword({
      //   variables: {
      //     updateEnterpriseClientPasswordByIdId: authReducer.enterpriseClientID,
      //     currentPassword: userData.currentPassword,
      //     newPassword: userData.confirmPassword,
      //   },
      // });
    } catch (error) {
      //Animated Loader false
      dispatch(setLoaderFalse());

      toast.error(toastResponse('error', error));
    }
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={() => {
          props.onHide();
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className="modal-header px-8 pt-8 pb-4"
          closeButton
          style={{
            borderBottom: '#fff',
            margin: '0%',
            alignItems: 'flex-start',
          }}
        >
          <Modal.Title>
            <span className="fw-bolder">
              {' '}
              Change {props?.userName ? 'User' : ''} Password
            </span>
            <span className="info-icon cursor-pointer mx-2">
              <CustomTooltip text={tooltipContent}>
                <img
                  alt="info"
                  src={allImages.infoIcon}
                  className="w-15px img-fluid"
                />
              </CustomTooltip>
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="px-8 py-0 modal-body"
          style={{ borderBottom: '#fff', margin: '0%' }}
        >
          <p
            className="fs-5"
            style={{ display: props?.userName ? 'block' : 'none' }}
          >
            Are you sure you want to change password for{' '}
            <b>{props?.userName}</b> ?
          </p>

          <form className="form w-100 w-lg-450  h-100">
            <div className="mb-6">
              <Form.Label>Current Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={currentPasswordToggle ? 'password' : 'text'}
                  className="form-control form-control-lg form-control-solid fs-6 "
                  autoComplete="current-password"
                  onChange={(e) => {
                    setUserData((userData) => ({
                      ...userData,
                      currentPassword: e.target.value,
                    }));
                  }}
                />
                <div className="showPasswordBlock">
                  <img
                    src={allImages.showPwd}
                    className="container-fluid"
                    style={{
                      display: !currentPasswordToggle ? 'block' : 'none',
                    }}
                    onClick={(e) => {
                      setCurrentPasswordToggle(
                        (currentPasswordToggle) => !currentPasswordToggle,
                      );
                    }}
                    alt="show_password_icon"
                  />
                  <img
                    src={allImages.hidePwd}
                    className="container-fluid"
                    style={{
                      display: currentPasswordToggle ? 'block' : 'none',
                    }}
                    onClick={(e) =>
                      setCurrentPasswordToggle(
                        (currentPasswordToggle) => !currentPasswordToggle,
                      )
                    }
                    alt="hide_password_icon"
                  />
                </div>
              </div>
              {/* <Form.Control.Feedback type='required' autoComplete="new-password" style={{ color: 'red', fontSize: '0.875em', marginTop: '0.25rem' }}>
                                {errors.passwordError}
                            </Form.Control.Feedback> */}
            </div>

            <div className="mb-6">
              <Form.Label>New Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={passwordToggle ? 'password' : 'text'}
                  className="form-control form-control-lg form-control-solid fs-6 "
                  autoComplete="new-password"
                  isInvalid={errors.password}
                  onChange={(e) => {
                    setUserData((userData) => ({
                      ...userData,
                      password: e.target.value,
                    }));
                    comparePasswords(
                      'password',
                      e.target.value,
                      userData.confirmPassword,
                      setError,
                    );
                  }}
                />
                <div className="showPasswordBlock">
                  <img
                    src={allImages.showPwd}
                    className="container-fluid"
                    style={{ display: !passwordToggle ? 'block' : 'none' }}
                    onClick={(e) => {
                      setPasswordToggle((passwordToggle) => !passwordToggle);
                    }}
                    alt="show_password_icon"
                  />
                  <img
                    src={allImages.hidePwd}
                    className="container-fluid"
                    style={{ display: passwordToggle ? 'block' : 'none' }}
                    onClick={(e) =>
                      setPasswordToggle((passwordToggle) => !passwordToggle)
                    }
                    alt="hide_password_icon"
                  />
                </div>
              </div>
              <Form.Control.Feedback
                type="required"
                autoComplete="new-password"
                style={{
                  color: 'red',
                  fontSize: '0.875em',
                  marginTop: '0.25rem',
                }}
              >
                {errors.passwordError}
              </Form.Control.Feedback>
            </div>

            <div className="mb-6">
              {/* <Form.Label className='loginRegisterBlock formControlLabel text-dark w-100'>
                                <span>Confirm Password</span>
                            </Form.Label> */}
              <div className="position-relative">
                <Form.Label>Confirm Password</Form.Label>

                <Form.Control
                  type={confirmPasswordToggle ? 'password' : 'text'}
                  className="form-control form-control-lg form-control-solid fs-6 "
                  isInvalid={errors.confirmPassword}
                  onChange={(e) => {
                    setUserData((userData) => ({
                      ...userData,
                      confirmPassword: e.target.value,
                    }));
                    comparePasswords(
                      'confirmpassword',
                      e.target.value,
                      userData.password,
                      setError,
                    );
                  }}
                />
                <div className="showPasswordBlock">
                  <img
                    src={allImages.showPwd}
                    className="container-fluid"
                    style={{
                      display: !confirmPasswordToggle ? 'block' : 'none',
                    }}
                    onClick={(e) => {
                      setConfirmPasswordToggle(
                        (confirmPasswordToggle) => !confirmPasswordToggle,
                      );
                    }}
                    alt="show_password_icon"
                  />
                  <img
                    src={allImages.hidePwd}
                    className="container-fluid"
                    style={{
                      display: confirmPasswordToggle ? 'block' : 'none',
                    }}
                    onClick={(e) =>
                      setConfirmPasswordToggle(
                        (confirmPasswordToggle) => !confirmPasswordToggle,
                      )
                    }
                    alt="hide_password_icon"
                  />
                </div>
              </div>
              <Form.Control.Feedback
                type="required"
                style={{
                  color: 'red',
                  fontSize: '0.875em',
                  marginTop: '0.25rem',
                }}
              >
                {errors.confirmPasswordError}
              </Form.Control.Feedback>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer
          className="pt-0 px-8 pb-8 modal-footer"
          style={{ borderTop: '#fff', margin: '0%' }}
        >
          <div className="text-end">
            <button
              type="button"
              className="customTable action-btn btn btn-primary btn-hover-color"
              // disabled={!(userData.password && userData.confirmPassword && !errors.password && !errors.confirmPassword)}
              onClick={() => {
                fnChangePassword();
              }}
            >
              Change Password
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <BasicPopup
        show={showBasicPopup}
        onHide={() => setShowBasicPopup(false)}
        f
        popupTitle="Password Changed Successfully"
        popupSubTitle={'Password Changed Successfully'}
        otherButtonText={''}
      />
    </>
  );
};
